import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { IViewsDropdown } from "../../../src/taskpane/interfaces/IViewsDropdown";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { List20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/List20Regular";

export function useMenuItem_Views(
  viewsWithColumns: IViewsDropdown[],
  selectedView: IViewsDropdown,
  setSelectedView: (view: IViewsDropdown) => void,
  // quickFilterValue: string,
  libraryMinVerEnabled: boolean
) {
  const languageStrings = React.useContext(LanguageContext);

  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
  const minVersionLimit = useSelector((state: RootState) => state.tenantInfo?.minVersionLimit);

  const menuItem_Views = React.useMemo(() => {

    const viewItems = viewsWithColumns.reduce<IContextualMenuItem[]>((acc, view) => {
      if (!view.isReport || (view.isReport && libraryMinVerEnabled && minVersionLimit)) {
        acc.push({
          key: view.key.toString(),
          canCheck: true,
          checked: view.key === selectedView?.key,
          text: view.text,
          onClick: () => setSelectedView(view),
        });
      }
      return acc;
    }, []);

    return {
      key: "views",
      disabled: viewsWithColumns.length === 0 || isBusySaving,
      text: selectedView ? selectedView.text : languageStrings.Views,
      // iconProps: { iconName: "List" },
      iconProps: {},
      onRenderIcon: () => <List20Regular className={menuItemIconStyles} />,
      subMenuProps: {
        items: viewItems,
      },
    } as IContextualMenuItem;

  }, [
    viewsWithColumns,
    selectedView,
    setSelectedView,
    // quickFilterValue,
    libraryMinVerEnabled,
    isBusySaving,
    minVersionLimit,
    languageStrings
  ]);

  return {
    menuItem_Views
  };

}